import React from 'react';
import Loading from '../../../Components/Loading';
import InfiniteScroll from 'react-infinite-scroll-component';

interface FlatListProps {
	data: any[];
	renderItem: (item: any) => React.ReactElement;
	onRefresh: () => void;
	onLoadMore: () => void;
	hasMoreData: boolean;
	isLoading: boolean;
	scrollableTargetId?: string;
	className?: string;
	itemKey?: string;
}

const FlatList: React.FC<FlatListProps> = ({
	data,
	renderItem,
	onRefresh,
	onLoadMore,
	hasMoreData,
	scrollableTargetId,
	className,
	itemKey,
	isLoading,
}: FlatListProps) => {
	if (isLoading) {
		return <Loading />;
	}

	return (
		<InfiniteScroll
			dataLength={data.length}
			refreshFunction={onRefresh}
			next={onLoadMore}
			hasMore={hasMoreData}
			loader={<Loading />}
			scrollableTarget={scrollableTargetId}
			className={className}>
			{data?.map((item: any, index) => (
				<React.Fragment key={itemKey ? item[itemKey] : index}>
					{renderItem(item)}
				</React.Fragment>
			))}
		</InfiniteScroll>
	);
};

export default FlatList;
